import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=b4050704&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"
import style0 from "./NewMessage.vue?vue&type=style&index=0&id=b4050704&prod&lang=scss"
import style1 from "./NewMessage.vue?vue&type=style&index=1&id=b4050704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4050704",
  null
  
)

export default component.exports